import { IShiftProgramBindingRow } from 'types/shiftProgramBindings.interface'

export const MOCK_SHIFT_PROGRAM_BINDINGS: IShiftProgramBindingRow[] = [
  {
    id: 1,
    task: 'Equipment fuel check',
    locations: [
      'Mine A > Section N > Block N-1 > Pit N-1-A (PIT)',
      'Mine A > Section N > Block N-1 > Pit N-1-B (PIT)',
    ],
    workersPerLocation: '1 worker per location',
  },
]
